import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterComponent } from './footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoRootModule } from '../../../app/transloco/transloco-root.module';

@NgModule({
	imports: [CommonModule, MatButtonModule, MatIconModule, TranslocoRootModule, FooterComponent],
	exports: [FooterComponent],
})
export class FooterModule {}
